import React from "react";
import { useMsal } from "@azure/msal-react";
import LogInMicrosoft from "./LoginClass";

const LogInMicrosoftWrapper = (props) => {
  const { instance } = useMsal();
  return <LogInMicrosoft instance={instance} {...props} />;
};

export default LogInMicrosoftWrapper;